/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromImportResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromImportResponse(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromImportResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromImportResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromImportResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromImportResponse.js.map